(function () {
    'use strict';
    var key = 'mnc_cookie_consent_v1', consentTtlMs = 30 * 24 * 60 * 60 * 1000, banner = document.querySelector('[data-cookie-banner]');
    if (!banner) return;
    var settings = banner.querySelector('[data-cookie-settings]'), toggle = banner.querySelector('[data-cookie-settings-toggle]');
    var accept = banner.querySelector('[data-cookie-accept]'), reject = banner.querySelector('[data-cookie-reject]'), save = banner.querySelector('[data-cookie-save]');
    var prefs = document.querySelector('[data-cookie-preferences]'), optional = banner.querySelector('[data-cookie-category="optional"]');
    var analyticsCookieNames = ['_ga', '_gid', '_gat'];
    var analyticsCookiePrefixes = ['_ga_', '_gat_'];
    var marketingCookieNames = ['_fbp', '_fbc', '_gcl_au', '_gcl_aw', '_gcl_dc'];
    var marketingCookiePrefixes = ['_gcl_aw_', '_gcl_dc_'];
    function read() {
        try {
            var saved = JSON.parse(localStorage.getItem(key));
            var savedAt = saved && Date.parse(saved.savedAt);

            if (!saved || !saved.savedAt || !Number.isFinite(savedAt) || Date.now() - savedAt >= consentTtlMs) {
                localStorage.removeItem(key);
                clearDeniedTrackingCookies({analytics:false, marketing:false});
                return null;
            }

            return saved;
        } catch (e) {
            localStorage.removeItem(key);
            clearDeniedTrackingCookies({analytics:false, marketing:false});
            return null;
        }
    }
    function updateConsentSignals(consent) {
        var optionalEnabled = consent.analytics === true && consent.marketing === true;
        window.dataLayer = window.dataLayer || [];
        window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
        window.gtag('consent', 'update', {
            analytics_storage: optionalEnabled ? 'granted' : 'denied',
            ad_storage: optionalEnabled ? 'granted' : 'denied',
            ad_user_data: optionalEnabled ? 'granted' : 'denied',
            ad_personalization: optionalEnabled ? 'granted' : 'denied'
        });

        if (typeof window.fbq === 'function') {
            window.fbq('consent', optionalEnabled ? 'grant' : 'revoke');
        }
    }
    function deleteCookie(name) {
        var expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
        var hostname = window.location.hostname;
        var parts = hostname.split('.');
        var parentDomain = parts.length > 2 ? parts.slice(-2).join('.') : hostname;
        var domains = [hostname, '.' + hostname, parentDomain, '.' + parentDomain];
        document.cookie = name + '=; expires=' + expires + '; Max-Age=0; path=/';
        domains.filter(function (domain, index) { return domains.indexOf(domain) === index; }).forEach(function (domain) {
            document.cookie = name + '=; expires=' + expires + '; Max-Age=0; path=/; domain=' + domain;
        });
    }
    function deleteMatchingCookies(names, prefixes) {
        document.cookie.split(';').forEach(function (cookie) {
            var name = cookie.split('=')[0].trim();
            var matchesName = names.indexOf(name) !== -1;
            var matchesPrefix = prefixes.some(function (prefix) { return name.indexOf(prefix) === 0; });
            if (matchesName || matchesPrefix) deleteCookie(name);
        });
    }
    function clearDeniedTrackingCookies(consent) {
        if (consent.analytics !== true || consent.marketing !== true) {
            deleteMatchingCookies(analyticsCookieNames, analyticsCookiePrefixes);
            deleteMatchingCookies(marketingCookieNames, marketingCookiePrefixes);
        }
    }
    function revokeServices(previous, consent) {
        var previouslyEnabled = previous && previous.analytics === true && previous.marketing === true;
        var optionalEnabled = consent.analytics === true && consent.marketing === true;

        clearDeniedTrackingCookies(consent);
        if (previouslyEnabled && !optionalEnabled) updateConsentSignals(consent);

        return previouslyEnabled && !optionalEnabled;
    }
    function loadServices(consent) {
        updateConsentSignals(consent);
        if (consent.analytics !== true || consent.marketing !== true) return;
        document.documentElement.setAttribute('data-analytics-consent', 'granted');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
        var gtm = document.createElement('script'); gtm.async = true; gtm.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-TQ75D3Q'; document.head.appendChild(gtm);
        if (!document.querySelector('[data-mnc-gtm-noscript]')) {
            var gtmFrame = document.createElement('iframe');
            gtmFrame.setAttribute('data-mnc-gtm-noscript', '');
            gtmFrame.src = 'https://www.googletagmanager.com/ns.html?id=GTM-TQ75D3Q';
            gtmFrame.height = '0'; gtmFrame.width = '0';
            gtmFrame.style.display = 'none'; gtmFrame.style.visibility = 'hidden';
            document.body.appendChild(gtmFrame);
        }
    }
    function saveConsent(consent) {
        var shouldReload = revokeServices(existing, consent);
        consent.version = 1;
        consent.savedAt = new Date().toISOString();
        localStorage.setItem(key, JSON.stringify(consent));
        existing = consent;
        banner.hidden = true;
        prefs.hidden = false;

        if (shouldReload) {
            window.location.reload();
        } else {
            loadServices(consent);
        }
    }
    function openSettings() { settings.hidden = false; toggle.hidden = true; accept.hidden = true; reject.hidden = true; save.hidden = false; }
    toggle.addEventListener('click', openSettings);
    accept.addEventListener('click', function () { saveConsent({analytics:true, marketing:true}); });
    reject.addEventListener('click', function () { saveConsent({analytics:false, marketing:false}); });
    save.addEventListener('click', function () { saveConsent({analytics:optional.checked, marketing:optional.checked}); });
    prefs.addEventListener('click', function () { banner.hidden = false; prefs.hidden = true; openSettings(); });
    var existing = read();
    if (existing && existing.version === 1) {
        var existingOptionalEnabled = existing.analytics === true && existing.marketing === true;
        existing.analytics = existingOptionalEnabled;
        existing.marketing = existingOptionalEnabled;
        localStorage.setItem(key, JSON.stringify(existing));
        optional.checked = existingOptionalEnabled;
        clearDeniedTrackingCookies(existing);
        loadServices(existing);
        prefs.hidden = false;
    } else {
        updateConsentSignals({analytics:false, marketing:false});
        banner.hidden = false;
    }
}());
